import "../styles/location.css";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaClock,
} from "react-icons/fa";

function Location() {
  return (
    <>
      

      {/* Location */}

      <section className="location-section">

        <div className="section-title">
          <h2>Visit Our Clinic</h2>

          <p>
            We are committed to providing professional hearing care with
            personalized solutions for every patient.
          </p>
        </div>

        <div className="location-container">

          <div className="location-box">

            <div className="map" data-aos="zoom-in" data-aos-duration="900" data-aos-delay="0">
      
              <iframe
                title="Mylapore Branch"
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d124369.19340814133!2d80.198822!3d13.065098!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52687f7ddb2d11%3A0x9385faff8a06f2c9!2sJAGADISH%20HEARING%20AIDS!5e0!3m2!1sen!2sin!4v1762422686105!5m2!1sen!2sin"
                loading="lazy"
                allowFullScreen
              ></iframe>
            </div>

            <div className="location-details">


              <p>
                <FaMapMarkerAlt className="icon" />
                New No.5, Old No.3, Kutchery Road,
                Mylapore, Chennai - 600004
              </p>

              <p>
                <FaPhoneAlt className="icon" />
                +91 94448 51663, +91 94451 15548
              </p>

              <p>
                <FaEnvelope className="icon" />
                jagadishhearingaidschennai@gmail.com
              </p>

              <p>
                <FaClock className="icon" />
                Monday - Saturday | 10:00 AM - 07:00 PM
              </p>

            </div>

          </div>

        </div>

      </section>
    </>
  );
}

export default Location;